import React from 'react';
import localStrings from "../../../localStrings";
import {MODE_CREATE} from "../../../components/CrudFrom/GeneralEditor";
import BrandCreateUpdateForm from "../AccountCreateUpdateView/BrandCreateUpdateForm";
import PageWithTitle from "../../../components/pages/pageWithTitle";


const AccountAddView = () => {

  function getMainButtons() {
    return null;
  }

  return (
    <PageWithTitle title={localStrings.addAccount} mainButtons={getMainButtons()}>
      <BrandCreateUpdateForm modeEdit={MODE_CREATE}/>
    </PageWithTitle>
  );
};

export default AccountAddView;
